import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { ApOperationsT } from './types';

/** Hook to fetch all the ops lines.  */
export const useOperationsQuery = ({
    year,
    expenseOrIncome,
    apId,
    enabled,
}: {
    year: number;
    expenseOrIncome: string;
    apId: number;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: ['allApsView', expenseOrIncome.toUpperCase(), year, apId],

        queryFn: async () => {
            const response = await RQAPICallWithData<ApOperationsT[]>({
                endpoint: `budget_overview/ap/${apId}/${expenseOrIncome.toLowerCase()}?year=${year}`,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled,
        refetchOnWindowFocus: false,
    });
